var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"logo",attrs:{"title":"运动秀,FitShow"}},[_c('router-link',{attrs:{"to":_vm.url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }